function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import React, { useEffect, useState } from 'react';
import FontAwesome from 'react-fontawesome';
import { Box, Button, Field, Form, FormControl, FormControlLabel, Grid, Radio, RadioGroup, SubmitButton, TextField, Typography } from '@applyboard/ui-components';
import { useToasts } from '@applyboard/crystal-ui';
import { useEventTracker, camelizeProperties } from '@applyboard/ui-utils';
import { applicationSetPreviewRequirementFileIdAction } from "../../../../../store/actions/application";
import { getSingleApplicationRequirementAction, updateAttachmentAction } from "../../../../../api/jsonapi";
import useInitialProps from "../../../../../hooks/useInitialProps";
import useDispatch from "../../../../../hooks/useDispatch";
import { useDocumentDiscrepancy } from "../../../../../data/documentDiscrepancy";
import { ResolveAttachmentDiscrepancyModal } from "../../../ResolveAttachmentDiscrepancyModal";
import { _ErrorPreviewWrapper, _RequirementPreviewContainer, RequirementPreviewFile, _RequirementPreviewText } from "../style";
import { strings } from "./strings";
import { checkHasWarnings, getAcceptOrRejectAttachmentEventData, getFlaggedDocumentEventData, getNextAttachmentIndex, getPrevAttachmentIndex, shouldShowDiscrepancyInfo } from "./utils";
import handleApiErrorResponse from "../../../../../util/handleApiErrorResponse";
import LeftArrow from "../../../../../components/Slider/LeftArrow";
import RightArrow from "../../../../../components/Slider/RightArrow";
var PreviewLink = function PreviewLink(_ref) {
  var link = _ref.link,
    contentType = _ref.contentType,
    previewable = _ref.previewable;
  if (!link) {
    return /*#__PURE__*/React.createElement(RequirementPreviewFile, null, "Attachment has no link.");
  }
  if (!previewable) {
    return /*#__PURE__*/React.createElement(RequirementPreviewFile, null, "This file can\u2018t be previewed. To view the content, please \xA0", /*#__PURE__*/React.createElement("a", {
      href: link
    }, "download"), ".");
  }
  return /*#__PURE__*/React.createElement(RequirementPreviewFile, null, contentType !== null && contentType !== void 0 && contentType.includes('image') ? /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: link
  }) : /*#__PURE__*/React.createElement("iframe", {
    title: "i-frame-2",
    src: link
  }));
};
var FilePreview = function FilePreview(_ref2) {
  var _requirement$attachme, _requirement$attachme2;
  var selectedPreviewRequirementFileId = _ref2.selectedPreviewRequirementFileId,
    onSuccess = _ref2.onSuccess,
    requirement = _ref2.requirement,
    VerificationResults = _ref2.VerificationResults;
  var _useInitialProps = useInitialProps(),
    application = _useInitialProps.application,
    plagiarismFeatureFlagEnabled = _useInitialProps.plagiarismCheckEnabled,
    permissions = _useInitialProps.permissions,
    role = _useInitialProps.role;
  var dispatch = useDispatch();
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var toasts = useToasts();
  var _useDocumentDiscrepan = useDocumentDiscrepancy({
      resourceId: requirement.id,
      resourceType: 'application_requirements',
      enabled: permissions === null || permissions === void 0 ? void 0 : permissions.view_internal_notices
    }),
    documentDiscrepancyMapping = _useDocumentDiscrepan.documentDiscrepancyMapping;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    resolveDiscrepancyModalOpen = _useState2[0],
    setResolveDiscrepancyModalOpen = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAttachmentStatus = _useState4[0],
    setSelectedAttachmentStatus = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loadingDisapproval = _useState6[0],
    setLoadingDisapproval = _useState6[1];
  var currentAttachmentIndex = requirement === null || requirement === void 0 ? void 0 : (_requirement$attachme = requirement.attachments) === null || _requirement$attachme === void 0 ? void 0 : _requirement$attachme.findIndex(function (item) {
    return item.id === selectedPreviewRequirementFileId;
  });
  var currentAttachment = requirement === null || requirement === void 0 ? void 0 : (_requirement$attachme2 = requirement.attachments) === null || _requirement$attachme2 === void 0 ? void 0 : _requirement$attachme2[currentAttachmentIndex];

  // TODO: try to remove this https://beta.reactjs.org/learn/you-might-not-need-an-effect
  useEffect(function () {
    if (currentAttachment) {
      setSelectedAttachmentStatus(currentAttachment.status);
    }
  }, [currentAttachment]);
  if (!currentAttachment) {
    return /*#__PURE__*/React.createElement(_RequirementPreviewContainer, null, /*#__PURE__*/React.createElement(_ErrorPreviewWrapper, null, /*#__PURE__*/React.createElement(FontAwesome, {
      name: "file-text"
    }), "Selected requirement has no files"));
  }
  function onApproveAttachment() {
    return _onApproveAttachment.apply(this, arguments);
  }
  function _onApproveAttachment() {
    _onApproveAttachment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var requirementResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return dispatch(updateAttachmentAction({
              application_requirement_id: requirement.id,
              id: currentAttachment.id
            }, {
              status: 'approved'
            }));
          case 3:
            requirementResponse = _context.sent;
            if (requirementResponse) {
              dispatch({
                type: 'UPDATE_ATTACHMENT_STATUS',
                data: requirementResponse.body.data,
                id: currentAttachment.id
              });
            }
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            setSelectedAttachmentStatus(currentAttachment.status);
            handleApiErrorResponse(_context.t0);
          case 11:
            toasts.positive("Approved ".concat(currentAttachment.fileName));
            onSuccess();
            if (checkHasWarnings(currentAttachment.automatedVerificationResults)) {
              trackEvent({
                event: strings.events.FLAGGED_DOCUMENTS_ACCEPTED,
                data: getFlaggedDocumentEventData({
                  attachment: currentAttachment,
                  requirement: requirement,
                  role: role
                })
              });
            }
            if (!(currentAttachment.status === 'no_decision')) {
              trackEvent({
                event: strings.events.UPDATED_FILE_DECISION,
                data: getAcceptOrRejectAttachmentEventData({
                  attachment: currentAttachment,
                  requirement: requirement,
                  role: role,
                  oldValue: 'rejected',
                  newValue: 'accepted'
                })
              });
            } else {
              trackEvent({
                event: strings.events.ACCEPTED_FILES,
                data: getAcceptOrRejectAttachmentEventData({
                  attachment: currentAttachment,
                  requirement: requirement,
                  role: role,
                  oldValue: undefined,
                  newValue: undefined
                })
              });
            }
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return _onApproveAttachment.apply(this, arguments);
  }
  function onDisapproveAttachment(_x) {
    return _onDisapproveAttachment.apply(this, arguments);
  }
  function _onDisapproveAttachment() {
    _onDisapproveAttachment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(rejectionReason) {
      var requirementResponse, _requirementResponse, getRequirementResponse;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(currentAttachment.statusNote !== rejectionReason && currentAttachment.status === 'disapproved')) {
              _context2.next = 17;
              break;
            }
            setLoadingDisapproval(true);
            _context2.prev = 2;
            _context2.next = 5;
            return dispatch(updateAttachmentAction({
              application_requirement_id: requirement.id,
              id: currentAttachment.id
            }, {
              status_note: rejectionReason
            }));
          case 5:
            requirementResponse = _context2.sent;
            if (requirementResponse) {
              dispatch({
                type: 'UPDATE_ATTACHMENT_STATUS',
                data: requirementResponse.body.data,
                id: currentAttachment.id
              });
            }
            toasts.positive("Updated rejection reason for ".concat(currentAttachment.fileName));
            onSuccess();
            setLoadingDisapproval(false);
            _context2.next = 15;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            handleApiErrorResponse(_context2.t0);
          case 15:
            _context2.next = 35;
            break;
          case 17:
            _context2.prev = 17;
            _context2.next = 20;
            return dispatch(updateAttachmentAction({
              application_requirement_id: requirement.id,
              id: currentAttachment.id
            }, {
              status: 'disapproved',
              status_note: rejectionReason
            }));
          case 20:
            _requirementResponse = _context2.sent;
            if (_requirementResponse) {
              dispatch({
                type: 'UPDATE_ATTACHMENT_STATUS',
                data: _requirementResponse.body.data,
                id: currentAttachment.id
              });
            }
            _context2.next = 24;
            return dispatch(getSingleApplicationRequirementAction({
              id: requirement.id
            }));
          case 24:
            getRequirementResponse = _context2.sent;
            dispatch({
              type: 'UPDATE_REQUIREMENT_STATUS',
              data: getRequirementResponse.body.data
            });
            toasts.positive("Rejected ".concat(currentAttachment.fileName));
            onSuccess();
            setLoadingDisapproval(false);
            _context2.next = 35;
            break;
          case 31:
            _context2.prev = 31;
            _context2.t1 = _context2["catch"](17);
            setLoadingDisapproval(false);
            handleApiErrorResponse(_context2.t1);
          case 35:
            if (checkHasWarnings(currentAttachment.automatedVerificationResults)) {
              trackEvent({
                event: strings.events.FLAGGED_DOCUMENTS_REJECTED,
                data: getFlaggedDocumentEventData({
                  attachment: currentAttachment,
                  requirement: requirement,
                  role: role
                })
              });
            }
            if (!(currentAttachment.status === 'no_decision')) {
              trackEvent({
                event: strings.events.UPDATED_FILE_DECISION,
                data: getAcceptOrRejectAttachmentEventData({
                  attachment: currentAttachment,
                  requirement: requirement,
                  role: role,
                  oldValue: 'accepted',
                  newValue: 'rejected'
                })
              });
            } else {
              trackEvent({
                event: strings.events.REJECTED_FILES,
                data: getAcceptOrRejectAttachmentEventData({
                  attachment: currentAttachment,
                  requirement: requirement,
                  role: role,
                  oldValue: undefined,
                  newValue: undefined
                })
              });
            }
          case 37:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 12], [17, 31]]);
    }));
    return _onDisapproveAttachment.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(_RequirementPreviewContainer, null, /*#__PURE__*/React.createElement(Box, {
    m: 1
  }, /*#__PURE__*/React.createElement(_RequirementPreviewText, null, currentAttachment.fileName, currentAttachment.contentType.includes('image') && /*#__PURE__*/React.createElement("span", {
    css: "font-size: 1.5em;"
  }, /*#__PURE__*/React.createElement("a", {
    href: currentAttachment.fileDownloadLink,
    download: true,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "download",
    css: "color: #676a6c; margin-left: 10px;"
  })))), /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(RadioGroup, {
    onChange: function onChange(_, value) {
      setSelectedAttachmentStatus(value);
      if (value === 'approved') {
        if (shouldShowDiscrepancyInfo({
          documentDiscrepancy: documentDiscrepancyMapping[currentAttachment.id]
        })) {
          setResolveDiscrepancyModalOpen(true);
        } else {
          onApproveAttachment();
        }
      }
    },
    row: true,
    value: selectedAttachmentStatus
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "approved",
    control: /*#__PURE__*/React.createElement(Radio, {
      required: true
    }),
    label: /*#__PURE__*/React.createElement(Typography, null, "Accepted"),
    disabled: false
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "disapproved",
    control: /*#__PURE__*/React.createElement(Radio, {
      required: true
    }),
    label: /*#__PURE__*/React.createElement(Typography, null, "Rejected"),
    disabled: false
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, selectedAttachmentStatus === 'disapproved' ? /*#__PURE__*/React.createElement(Form, {
    key: currentAttachment.id,
    onSubmit: function onSubmit(data) {
      return onDisapproveAttachment(data.rejection_reason);
    },
    defaultValues: {
      rejection_reason: currentAttachment.statusNote
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1,
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Field, {
    name: "rejection_reason",
    label: "Rejection Reason",
    as: TextField,
    required: true,
    type: "text",
    variant: "outlined",
    helperText: "Enter rejection reason"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(SubmitButton, {
    as: Button,
    type: "submit",
    disableIfValuesUnchanged: true,
    loading: loadingDisapproval
  }, "Save")))) : null))), (permissions === null || permissions === void 0 ? void 0 : permissions.view_internal_notices) && /*#__PURE__*/React.createElement(VerificationResults, {
    key: currentAttachment.id,
    attachment: currentAttachment,
    requirement: camelizeProperties(requirement),
    applicationId: application === null || application === void 0 ? void 0 : application.id,
    plagiarismCheckEnabled: true,
    plagiarismFeatureFlagEnabled: plagiarismFeatureFlagEnabled,
    documentDiscrepancyMapping: documentDiscrepancyMapping
  })), requirement.attachments.length > 1 && /*#__PURE__*/React.createElement(Box, {
    mb: 10
  }, /*#__PURE__*/React.createElement(LeftArrow, {
    previousSlide: function previousSlide() {
      var prevAttachmentIndex = getPrevAttachmentIndex({
        attachments: requirement.attachments,
        currentAttachmentIndex: currentAttachmentIndex
      });
      dispatch(applicationSetPreviewRequirementFileIdAction(requirement.attachments[prevAttachmentIndex].id));
    },
    preview: true
  }), /*#__PURE__*/React.createElement(RightArrow, {
    nextSlide: function nextSlide() {
      var nextAttachmentIndex = getNextAttachmentIndex({
        attachments: requirement.attachments,
        currentAttachmentIndex: currentAttachmentIndex
      });
      dispatch(applicationSetPreviewRequirementFileIdAction(requirement.attachments[nextAttachmentIndex].id));
    },
    preview: true
  })), /*#__PURE__*/React.createElement(PreviewLink, {
    link: currentAttachment.fileDownloadLink,
    previewable: currentAttachment.previewable,
    contentType: currentAttachment.contentType
  }), resolveDiscrepancyModalOpen && documentDiscrepancyMapping[currentAttachment.id] && application.user_id && /*#__PURE__*/React.createElement(ResolveAttachmentDiscrepancyModal, {
    open: resolveDiscrepancyModalOpen,
    attachmentId: currentAttachment.id,
    documentDiscrepancy: documentDiscrepancyMapping[currentAttachment.id],
    onResolve: function onResolve() {
      return onApproveAttachment();
    },
    onClose: function onClose() {
      return setResolveDiscrepancyModalOpen(false);
    }
  }));
};
export default FilePreview;